import { RootState } from "app/store";
import { sitesAdapter } from "./state";

export const { selectAll: selectAllSites, selectById: selectSiteById } =
    sitesAdapter.getSelectors((state: RootState) => state.sites);
